import { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

import { ASSETS } from "@/assets/constants/paths";
import { LanguageSwitcher } from "@/components";
import { isActiveRoute, NAV_ITEMS, ROUTES, stripLocalePrefix, useLocalePath } from "@/navigations";

import styles from "./styles.module.css";

export const Navbar = memo(() => {
  const { t } = useTranslation("components");
  const location = useLocation();
  const lp = useLocalePath();
  const basePathname = stripLocalePrefix(location.pathname);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <header className={styles.header}>
      <nav className={styles.nav}>
        <Link to={lp(ROUTES.HOME)} className={styles.logo}>
          <img src={ASSETS.LOGO} alt="AquaWorks" className={styles.mark} width={32} height={32} />
          AquaWorks
        </Link>

        <ul className={styles.links}>
          {NAV_ITEMS.map((item) => (
            <li key={item.path}>
              <Link
                to={lp(item.path)}
                className={`${styles.link} ${isActiveRoute(basePathname, item.path) ? styles.active : ""}`}
              >
                {t(item.labelKey)}
              </Link>
            </li>
          ))}
        </ul>

        <div className={styles.actions}>
          <LanguageSwitcher />
          <button
            type="button"
            className={styles.burger}
            aria-label="Menu"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </nav>

      {open ? (
        <div className={styles.mobilePanel}>
          <ul className={styles.mobileLinks}>
            {NAV_ITEMS.map((item) => (
              <li key={item.path}>
                <Link
                  to={lp(item.path)}
                  className={`${styles.mobileLink} ${isActiveRoute(basePathname, item.path) ? styles.active : ""}`}
                >
                  {t(item.labelKey)}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </header>
  );
});

Navbar.displayName = "Navbar";
export default Navbar;
